<template>
  <div v-if="showbanner">
    <div class="Bigbox">
      <div class="title">
        <div>
          <!-- <div class="eng">Enterprise Qualification</div> -->
          <div class="text">企业资质</div>
          <div class="title-icon"></div>
        </div>
      </div>

      <div class="BixBoxSweiper">
        <div class="title titles">
          <div class="line_box">
            <div class="line_left"></div>
            <p>营业资质</p>
            <div class="line_right"></div>
          </div>
          <SwiperViews class="SwiperBox" :bannerlist="bannerlist[0]" :showswiper='showswiper'/>
          <div class="swiper_big">
            <el-carousel
              :interval="4000"
              type="card"
              arrow="always"
              height="224px"
            >
              <el-carousel-item
                class="swiper_item"
                v-for="(item, index) in bannerlist[0]"
                :key="index"
              >
                <div class="swiper_box" >
                  <img :src="$url+item.picture" alt="" class="swiper_img"  @click="showimg(bannerlist[0],index)"/>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>

        <div class="title titles">
          <div class="line_box">
            <div class="line_left"></div>
            <p>经营许可证书</p>
            <div class="line_right"></div>
          </div>
          <SwiperViews class="SwiperBox" :bannerlist="bannerlist[1]" :showswiper='showswiper'/>
          <div class="swiper_big">
            <el-carousel
              :interval="4000"
              type="card"
              arrow="always"
              height="224px"
            >
              <el-carousel-item
                class="swiper_item"
                v-for="(item, index) in bannerlist[1]"
                :key="index"
              >
                <div class="swiper_box">
                  <img :src="$url+item.picture" alt="" class="swiper_img"  @click="showimg(bannerlist[1],index)"/>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>

        <div class="title titles">
          <div class="line_box">
            <div class="line_left"></div>
            <p>网络服务资质证书</p>
            <div class="line_right"></div>
          </div>
          <div class="swiper_big">
            <el-carousel
              :interval="4000"
              type="card"
              arrow="always"
              height="224px"
            >
              <el-carousel-item
                class="swiper_item"
                v-for="(item, index) in bannerlist[2]"
                :key="index"
              >
                <div class="swiper_box">
                  <img :src="$url+item.picture" alt="" class="swiper_img" @click="showimg(bannerlist[2],index)"/>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>

          <SwiperViews class="SwiperBox" :bannerlist="bannerlist[2]"  :showswiper='showswiper'/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import Test from "./test.vue";
import SwiperViews from "./SwiperViews.vue";
export default {
  name: "Enterprise",
  data() {
    return {
      bannerlist: [],
      showbanner: false,
    };
  },
  props: {
    showswiper:Boolean
  },
  components: {
    Swiper,
    SwiperSlide,
    Test,
    SwiperViews,
  },
  mounted() {
    this.$http
      .post("/index/banner/list", {
        type: "qualifications",
      })
      .then((res) => {
        this.bannerlist = res.data.data;
        this.$nextTick(() => {
          this.showbanner = true;
        });
      });
  },
  methods: {
    showimg(item,i) {
      this.$emit('showimg',item,i)
    }
  },
};
</script>

<style lang="scss" scoped>
.SwiperBox {
  display: none;
}
.Bigbox {
  margin: 0 auto;
  width: 100%;

  // height: 1500px;
  background: linear-gradient(
    180deg,
    rgba(0, 165, 168, 0.25) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  background-image: url("../assets/imgbg.png");
  border-radius: 0px 0px 0px 0px;
  background-size: 100% 100%;
  .BixBoxSweiper {
    padding-top: 60px;
    padding-bottom: 45px;
  }
  .title {
    padding-top: 72px;
    display: flex;
    justify-content: center;
    .line_box {
      // margin-top: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    p {
      font-size: 30px;
      @media (min-width: 1024px) and (max-width: 1366px) {
        font-size: 26px;
      }
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      line-height: 1;
    }
    .line_left {
      margin-right: 6.5px;
      width: 38px;
      height: 0px;
      opacity: 1;
      border: 1px solid #333333;
    }
    .line_right {
      margin-left: 6.5px;
      width: 38px;
      height: 0px;
      opacity: 1;
      border: 1px solid #333333;
    }
    .eng {
      text-align: center;
      font-size: 24px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #33333380;
    }
    .text {
      text-align: center;
      margin-top: 16px;
      font-size: 36px;
      @media (min-width: 1024px) and (max-width: 1366px) {
        font-size: 30px;
      }
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #333333;
    }
    .title-icon {
      margin-top: 16px;
      width: 272px;
      height: 8px;
      background: linear-gradient(
        270deg,
        rgba(0, 164, 167, 0) 0%,
        #00a4a7 49%,
        rgba(0, 164, 167, 0) 100%
      );
    }
  }
  .titles {
    padding-top: 0px;
    // padding-bottom: 80px;
    margin-bottom: 25px;
    display: flex;
    flex-direction: column;
  }
  .swiper_big {
    margin: 55px auto;
    width: 1228px;
    text-align: center;
    .swiper_box {
      background-color: #fff;
      width: 332px !important;
      text-align: center;
      width: 50%;
      margin: 0 auto;
    }

    .swiper-button-next {
      right: 10vh;
      @media (max-width: 1200px) {
        right: 69.5vh;
      }
      // transform: rotate(90deg);
    }

    .swiper-button-prev {
      left: 10vh;
      transform: rotate(180deg);
      @media (max-width: 1200px) {
        left: 69.5vh;
      }
    }

    .swiper_img {
      width: 332px;
      height: 223px;
      object-fit: contain;
      object-position: 50% 20%;
    }

    .example-3d {
      width: 100%;
      height: 400px;
      padding-top: 50px;
      padding-bottom: 50px;
      > div {
        width: 1000px;
        margin: 0 auto;
        // overflow: hidden;
      }
    }

    .swiper-slide-next {
      opacity: 0.5;
    }
    .swiper-slide-prev {
      opacity: 0.5;
    }
    .swiper {
      height: 100%;
      width: 100%;

      .swiper-slide {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 300px;
        height: 300px;
        text-align: center;
        font-weight: bold;
        //   font-size: $font-size-huge * 2;
        background-color: #2c8dfb;
        background-position: center;
        background-size: cover;
        //   color: $white;
      }
    }
  }
}
@media (max-width: 768px) {
  .SwiperBox {
    margin-top: 20px;
    display: block;
  }
  .Bigbox {
    margin: 0 auto;
    width: 100%;

    // height: 1500px;
    background: linear-gradient(
      180deg,
      rgba(0, 165, 168, 0.25) 0%,
      rgba(255, 255, 255, 0) 100%
    );
    background-image: url("../assets/imgbg.png");
    border-radius: 0px 0px 0px 0px;
    background-size: 100% 100%;
    .BixBoxSweiper {
      padding-top: 45px;
      padding-bottom: 1px;
    }
    .title {
      padding-top: 22px;
      display: flex;
      justify-content: center;
      .line_box {
        // margin-top: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      p {
        font-size: 22px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 1;
      }
      .line_left {
        margin-right: 6.5px;
        width: 38px;
        height: 0px;
        opacity: 1;
        border: 1px solid #333333;
      }
      .line_right {
        margin-left: 6.5px;
        width: 38px;
        height: 0px;
        opacity: 1;
        border: 1px solid #333333;
      }
      .eng {
        text-align: center;
        font-size: 24px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #33333380;
      }
      .text {
        text-align: center;
        margin-top: 10px;
        font-size: 26px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #333333;
      }
      .title-icon {
        margin-top: 16px;
        width: 272px;
        height: 8px;
        background: linear-gradient(
          270deg,
          rgba(0, 164, 167, 0) 0%,
          #00a4a7 49%,
          rgba(0, 164, 167, 0) 100%
        );
      }
    }
    .titles {
      padding-top: 0px;
      // padding-bottom: 80px;
      margin-bottom: 45px;
      display: flex;
      flex-direction: column;
    }
    .swiper_big {
      display: none;
      margin: 55px auto;
      width: 100%;
      text-align: center;
      .swiper_box {
        width: 332px !important;
        text-align: center;
        width: 50%;
        margin: 0 auto;
      }

      .swiper-button-next {
        right: 10vh;
        @media (max-width: 1200px) {
          right: 69.5vh;
        }
        // transform: rotate(90deg);
      }

      .swiper-button-prev {
        left: 10vh;
        transform: rotate(180deg);
        @media (max-width: 1200px) {
          left: 69.5vh;
        }
      }

      .swiper_img {
        width: 100%;
        height: 100%;
      }

      .example-3d {
        width: 100%;
        height: 400px;
        padding-top: 50px;
        padding-bottom: 50px;
        > div {
          width: 100%;
          margin: 0 auto;
          // overflow: hidden;
        }
      }

      .swiper-slide-next {
        opacity: 0.5;
      }
      .swiper-slide-prev {
        opacity: 0.5;
      }
      .swiper {
        height: 100%;
        width: 100%;

        .swiper-slide {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 300px;
          height: 300px;
          text-align: center;
          font-weight: bold;
          //   font-size: $font-size-huge * 2;
          background-color: #2c8dfb;
          background-position: center;
          background-size: cover;
          //   color: $white;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Enterprise.vue